import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useRegistrationStatusChartsDataContext } from './hooks/useRegistrationStatusChartsDataContext';

export const CertificatePresented = () => {
    const { chartData } = useRegistrationStatusChartsDataContext();

    return (
        <SimpleBars
            title={'Certidão Apresentada'}
            horizontal={false}
            subtitles={chartData?.certificatePresented?.map((item) => item.description)}
            values={chartData?.certificatePresented?.map((item) => item.total  ||  0)}
             className='aligned-container'
        />
    );
};
